import { PropFormikField, PropSelectOptions } from "constant/prop-types";
import PropTypes from "prop-types";
import React from "react";
import Select, { Creatable } from "react-select";
import { arrayToSelectOptions, STYLES } from "util/select";

class SelectField extends React.PureComponent {
  static arrayToSelectOptions(simpleOpts) {
    return arrayToSelectOptions(simpleOpts || []);
  }

  static get propTypes() {
    return {
      field: PropFormikField.isRequired,
      form: PropTypes.object.isRequired,
      isCreatable: PropTypes.bool,
      isMulti: PropTypes.bool,
      onChange: PropTypes.func,
      options: PropSelectOptions,
      readOnly: PropTypes.bool,
    };
  }

  static get defaultProps() {
    return {
      isCreatable: false,
      isMulti: false,
      options: [],
      readOnly: false,
    };
  }

  constructor(props) {
    super(props);

    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  onChangeHandler(val) {
    const { field, form, onChange } = this.props;

    form.setFieldValue(field.name, val);

    if (onChange) {
      onChange(val);
    }
  }

  render() {
    const { field, isCreatable, options, readOnly, ...rest } = this.props;

    const SelectComponent = isCreatable ? Creatable : Select;

    return (
      <SelectComponent
        {...rest}
        isDisabled={readOnly}
        name={field.name}
        onChange={this.onChangeHandler}
        options={options}
        styles={STYLES}
        value={field.value}
        isClearable
      />
    );
  }
}

export { SelectField };
